const Secret = process.env.VUE_APP_SECRET;
const ApiUrl = process.env.VUE_APP_BASE_URL + "/v1/";
const ImgUrl = process.env.VUE_APP_IMG_URL;
const UploadUrl = process.env.VUE_APP_BASE_URL + "/upload";
const PageSize = 14;
const NotifyDuration = 3000;

const DeviceStatus = ['Online', 'Offline']
const DeviceModel = [
  'EVEMS ATC-101',
  'EVEMS ATC-201',
  'EVEMS ATC-301',
];
const CustomerTag = [
  // 'Owner',
  // 'Tenant',
  'House',
  'Apartment',
];
const AgentTag = [
  'Device Mgmt',
  'Tenant Mgmt',
];
const StatusTag = [
  'Signed',
  'Terminated',
  'Cooperation',
];

const AsideMenus = [
  {
    icon: "dashboard",
    title: "Dashboard",
    path: ["/dashboard/admin", "/dashboard/agent", "/dashboard/customer"],
    roles: ['admin', 'agent', 'customer']
  },
  {
    icon: "device",
    title: "Device",
    path: ["/device/list"],
    roles: ['admin', 'agent', 'customer']
  },
  {
    icon: "customer",
    title: "Customer",
    path: ["/customer/list", "/customer/list", "/customer/detail"],
    roles: ['admin', 'agent']
  },  
  {
    icon: "agent",
    title: "Agent",
    path: ["/agent/list", "/agent/detail"],
    roles: ['admin']
  },
];


export const consts = {
  Secret,
  ApiUrl,
  ImgUrl,
  UploadUrl,
  PageSize,
  NotifyDuration,
  DeviceStatus,
  DeviceModel,
  CustomerTag,
  AgentTag,
  StatusTag,
  AsideMenus,
};
